<bcu-local-spinner [size]="40" [visible]="(blockedSlot$ | async).isLoading" *ngIf="(blockedSlot$ | async).isLoading">
</bcu-local-spinner>
<div class="container  my-3" *ngIf="(blockedSlot$ | async).loaded && (blockedSlot$ | async).data as blockedSlot">
    <div class="row card shadow p-4 border-bottom no-gutters color-dark-gray-bg text-white">
        <div class="col">
            <div class="row no-gutters py-2 px-3">
                <div class="col-3">
                    <div class="font-weight-bold"><h3>{{blockedSlot.type.name}}</h3></div>
                    <div>{{'CourtEventDetails.BlockedSlotDetailsName' | translate}}</div>
                </div>
                <div class="col-8"></div>
                <div class="col-1 m-0 text-right" *ngIf="blockedSlot.isCancellationAvailable">
                    <button type="button" class="btn btn-light-red" (click)="onCancelClicked()">{{'CourtEventDetails.BlockedSlotCancelBtn' | translate}}</button>
                </div>
            </div>
            <div class="row no-gutters px-3">
                <div class="col-12">
                    <hr class="solid bg-white"/>
                </div>                    
            </div>
            <div class="row no-gutters py-2 px-3">
                <div class="col text-left">
                    <span class="ic_bs_calendar mr-2"></span> {{blockedSlot.date | bcDate: 'dddd'}}, {{blockedSlot.date | bcDate: 'MMM Do YY'}}
                </div>                    
                <div class="col text-left">
                    <span class="ic-cb-time mr-2"></span>
                    {{blockedSlot.timeFromInMinutes | timeDisplay : true}} -
                    {{blockedSlot.timeToInMinutes | timeDisplay}}
                </div>
                <div class="col text-left">
                    <span class="ic_bs_court mr-2"></span>
                    {{blockedSlot.court.name}} <span *ngIf="blockedSlot.court.tennisType">({{blockedSlot.court.tennisType.name}})</span>
                </div>
                <div class="col text-left">
                    <app-court-event-status-pill [status]="blockedSlot.status"></app-court-event-status-pill>
                </div>
                <div class="col">
                </div>
            </div>
            <div class="row no-gutters py-2 px-3">
                <div class="col-auto text-left">
                    <span class="ic_bs_recurring mr-2"></span>
                </div>
                <div class="col-2 text-md-left">
                    <div *ngIf="blockedSlot.recurring">
                        <div>{{ blockedSlot.recurring.daysOfWeek | bcWeekDays }}</div>
                        <div>{{ blockedSlot.recurring | bcRecurrenceEnds }}</div>
                    </div>
                    <div *ngIf="!blockedSlot.recurring" translate>BlockedSlot.IsNotRecurring</div>
                </div>
                <div class="col">
                </div>
            </div>

            <div class="row no-gutters px-3">
                <div class="col-12">
                    <hr class="solid bg-white"/>
                </div>                    
            </div>

            <div class="py-2 px-3">
                <app-court-event-notes-details [notes]="blockedSlot.notes"></app-court-event-notes-details>  
            </div>

            <div class="row no-gutters pt-2 px-3">
                <div class="col">
                    <span class="clickable" (click)="onAddNote()">{{'CourtEventDetails.AddNote' | translate}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="card mt-4" *ngIf="blockedSlot.timelineItems.length">        
        <app-court-event-timeline [timelines]="blockedSlot.timelineItems"></app-court-event-timeline>        
    </div>
</div>


